import template from "./reports-list.component.html";

class ReportsListComponentController {
  constructor(
    $stateParams,
    $interval,
    $window,
    ReportingService,
    SessionsService,
    StorageService,
  ) {
    'ngInject';
    this.$stateParams = $stateParams;
    this.$interval = $interval;
    this.$window = $window;
    this.ReportingService = ReportingService;
    this.StorageService = StorageService;
    this.SessionsService = SessionsService;
    this.page = null;
    this.reports = [];
    this.reportsPrev = null;
    this.reportsNext = null;
  }

  $onInit() {
    let managingOrgId = this.SessionsService.getCurrentDistributorKey();
    this.refreshReports(managingOrgId, this.page);
    this.refreshInterval = this.$interval(() => {
      this.refreshReports(managingOrgId, this.page);
    }, 7000);
  }

  $onDestroy() {
    if (this.refreshInterval) {
      this.$interval.cancel(this.refreshInterval);
    }
  }

  refreshReports(managingOrgId, page) {
    let params = { managingOrgId, page};
    this.ReportingService.getDeviceReportsByManagingOrgPage(params)
      .then(response => {
        this.reports = response.reports;
        this.reportsPrev = response.previous;
        this.reportsNext = response.next;
      }, error => {
        console.error('unable to load reports', error);
      });
  }

  isCompleted(report) {
    return this.ReportingService.isCompleted(report);
  }

  downloadUrl(report) {
    return this.ReportingService.downloadUrl(report);
  }

  paginateCall = function (forward) {
    let managingOrgId = this.SessionsService.getCurrentDistributorKey();
    if (forward) {
        this.refreshReports(managingOrgId, this.reportsNext);
        this.page = this.reportsNext;
    } else {
        this.refreshReports(managingOrgId, this.reportsPrev);
        this.page = this.reportsPrev;
    }
  };

}

export const ReportsListComponent = {
  template: template,
  controller: ReportsListComponentController,
};
